import type { ColumnDef } from "@tanstack/react-table";
import { buildAvatarDetailsColumn, buildCopyTextColumn, buildSegmentedButtonColumn } from "@/components/Table";
import type { SessionRegistrationRow } from "../types";

interface GetColumnsProps {
  onAttendanceUpdate: (id: string, value: string | null) => void;
  canAccessActivityManagement: boolean;
  isCompactLayout: boolean;
}

export function getColumns({
  onAttendanceUpdate,
  canAccessActivityManagement,
  isCompactLayout
}: GetColumnsProps): ColumnDef<SessionRegistrationRow, unknown>[] {
  return [
    ...buildAvatarDetailsColumn<SessionRegistrationRow>({
      isCompactLayout,
      getTitle: (row) => row.registration.person.displayName,
      getSubtitle: (row) => row.registration.person.mainProgramType?.name || "",
      getPicture: (row) => row.registration.person.profilePhoto || undefined,
      sortType: "text"
    }),
    buildCopyTextColumn<SessionRegistrationRow>({
      accessorKey: "pgaId",
      header: "PGA ID",
      copyFieldLabel: "PGA ID",
      getText: (row) => row.registration.person.pgaId,
      enableSorting: false
    }),
    buildSegmentedButtonColumn<SessionRegistrationRow>({
      id: "attendance",
      header: "Attendance",
      options: [
        { label: "Present", value: "true" },
        { label: "Absent", value: "false" }
      ],
      getValue: (row) => (row.attended === null ? null : String(row.attended)),
      onChange: (row, value) => onAttendanceUpdate(row.id, value),
      disabled: !canAccessActivityManagement,
      compactLabel: (row) => (row.attended === true ? "Present" : row.attended === false ? "Absent" : "--"),
      size: 300
    })
  ];
}
